import { render, staticRenderFns } from "./OriginMarketList.vue?vue&type=template&id=3331e1d8&scoped=true"
import script from "./OriginMarketList.vue?vue&type=script&lang=js"
export * from "./OriginMarketList.vue?vue&type=script&lang=js"
import style0 from "./OriginMarketList.vue?vue&type=style&index=0&id=3331e1d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3331e1d8",
  null
  
)

export default component.exports